import React from 'react';

export const QarContext = React.createContext<{ qar: number }>({ qar: -1 });
export const useQarContext = () => React.useContext(QarContext);
